import React, { Component } from 'react'
import { translate, Translate } from 'react-i18nify'

import Panel from '../../Panel/Panel'

export default class ApplicationHandbook extends Component {
    render() {
        return (
            <Panel
                className="panel--multi__inner"
                headerText={translate('profile.application_handbook.title')}
                headerIcon="icon-book-open"
            >
                <div>
                    <p>{translate('profile.application_handbook.body')}</p>
                    <a className="button--cta" href="/pdf/Sollicitatie_Handboek.pdf" download>
                        {translate('profile.application_handbook.button')}
                    </a>
                </div>
                <br />
            </Panel>
        )
    }
}
